import {useQuery} from '@tanstack/react-query';
import {getQepSystem} from '../utils/get-qep-system';

/**
 * React Query hook that fetches the list of exchanges (segment MICs) the
 * current user is entitled to trade on. The result is cached forever because
 * exchange entitlements don't change mid-session.
 */
export function useExchangeSymbols() {
  return useQuery({
    queryKey: ['exchange-symbols'],
    async queryFn() {
      return getQepSystem().apiServices.marketdata.listExchanges();
    },
    staleTime: Number.POSITIVE_INFINITY,
  });
}
